import { render } from "./SearchEntry.vue?vue&type=template&id=5a157f3a&scoped=true"
import script from "./SearchEntry.vue?vue&type=script&lang=js"
export * from "./SearchEntry.vue?vue&type=script&lang=js"

import "./SearchEntry.vue?vue&type=style&index=0&id=5a157f3a&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\bgnnuserinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a157f3a"]])

export default __exports__